import React from "react"
import Layout from "../components/layout"
import { Container, Row } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import LabMember from "../components/labMember"
import ResearchDetail from "../components/researchDetail"
import Position from "../components/positions"
import Tools from "../components/tools"
import News from "../components/news"
import CarouselPolleux from "../components/carousel"
import typography from "./../utils/typography"
import LabManager from "../components/labManager"
import Funders from "../components/funders"
import Iascone from "../images/iascone.mp4"
import { GoLinkExternal } from "react-icons/go"
import {Helmet} from "react-helmet"


typography.injectStyles()

export default function Index() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>PolleuxLab</title>
      </Helmet>
      <div className="backgroundHeader">
        <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          zIndex: "10",
          objectFit: "cover",
          height: "100%",
          width: "100%",
          left: "50%",
          top: "50%",
          transform: "translate(-50%,-50%)"
        }}>
          <source src={Iascone} type="video/mp4" />
          <track/>
        </video>




        <div className="topleft"
             onClick={() => {
               window.open("https://zuckermaninstitute.columbia.edu/")
             }}
       style={{zIndex: "20"}} >
          <h1 style={{ color: "floralWhite", fontSize: "2vw"}}>
            COLUMBIA | Zuckerman Institute
          </h1>
        </div>

        <div style={{ flexDirection: "column", padding: "15px", zIndex: "20"}}>
          <h1
            style={{
              color: "floralWhite",
              textAlign: "center",
              fontSize: "4vw",
            }}
          >
            Polleux Lab
          </h1>
          <hr className="hr"/>
          <h2
            style={{
              color: "floralWhite",
              textAlign: "center",
              fontSize: "4vw",
            }}
          >
            Circuit development, evolution and maintenance
          </h2>
        </div>
      </div>
      <Layout>
        <Container className="sectionResearch" fluid="true">
          <ResearchDetail/>
        </Container>

        <div className="separator"/>

        <CarouselPolleux/>
        <div className="separator"/>


        <Container id="people" className="sectionPeople" fluid="true">
          <Row>
            <h1 className="peopleTitle">The Team</h1>
          </Row>
          <Row style={{ justifyContent: "space-evenly" }}>
            <LabMember/>
            <LabManager/>
          </Row>
          <Row>
            <a
              href="/alumni"
              className="alumniLink"
              style={{ paddingTop: "5px" }}
            >
              Alumni Members
            </a>
          </Row>
        </Container>

        <Container id="tools" className="sectionTools" fluid="true">

          <h1 className="peopleTitle">
            A sneak peak at some of our Tools
          </h1>

          <Row>
            <Tools/>
          </Row>
          <Row>
            <a
              href="https://www.addgene.org/Franck_Polleux/"
              className="alumniLink"
              target="_blank"
              rel="noopener noreferrer"
              style={{ paddingTop: "5px" }}
            >
              Addgene Plasmids
              <GoLinkExternal/>
            </a>

            </Row>




        </Container>

        <Container id="publications" className="sectionNews" fluid="true">

          <h1 className="peopleTitle">Publications and News</h1>
          <div>
            <News/>
          </div>
        </Container>
        <div className="separatorFunders"/>
        <Container id="funders" className="sectionFunders" fluid="true">
          <Funders/>
        </Container>
        <div className="separatorFunders"/>

      </Layout>
    </>
  )
} // Use Card Colums?
//  <div className="dividerPublications"/>
// <div className="dividerPositions"/>
/* <div className="dividerNews"/>
        <div className="dividerTools"/>
        <div className="dividerPeople"/>

 */
